function switchVariant(button, productId, sectionId, soldOutBadgeColorScheme, soldOutText, discountBadgeColorScheme, discountText) {
    const newImageUrl = button.getAttribute('data-image-url');
    const newVariantPrice = button.getAttribute('data-variant-price');
    const newVariantId = button.getAttribute('data-variant-id');
    const mainImage = document.getElementById(`main-product-image-${productId}`);
    const secondaryImage = document.getElementById(`secondary-product-image-${productId}`);
    const newsSecondImageUrl = button.getAttribute('data-metafield');
    const priceElement = document.querySelector(`.product-price-${productId} .money`);
    const productLink = document.getElementById(`CardLink-${sectionId}-${productId}`);
    const productLinkCard = document.getElementById(`StandardCardNoMediaLink-${sectionId}-${productId}`);
    const badgeElement = document.getElementById(`NoMediaStandardBadge-${sectionId}-${productId}`);

    // Update the product image
    if (newImageUrl && mainImage) {
        mainImage.src = newImageUrl;
        const srcsetTemplate = `
        ${newImageUrl.replace('width=533', 'width=165')} 165w,
        ${newImageUrl.replace('width=533', 'width=360')} 360w,
        ${newImageUrl.replace('width=533', 'width=533')} 533w,
        ${newImageUrl.replace('width=533', 'width=720')} 720w,
        ${newImageUrl.replace('width=533', 'width=940')} 940w,
        ${newImageUrl.replace('width=533', 'width=1066')} 1066w
      `;
        mainImage.srcset = srcsetTemplate.trim();
    }

    if (newsSecondImageUrl && secondaryImage) {
        secondaryImage.src = newsSecondImageUrl;
        const srcsetTemplate2 = `
        ${newsSecondImageUrl.replace('width=533', 'width=165')} 165w,
        ${newsSecondImageUrl.replace('width=533', 'width=360')} 360w,
        ${newsSecondImageUrl.replace('width=533', 'width=533')} 533w,
        ${newsSecondImageUrl.replace('width=533', 'width=720')} 720w,
        ${newsSecondImageUrl.replace('width=533', 'width=940')} 940w,
        ${newsSecondImageUrl.replace('width=533', 'width=1066')} 1066w
      `;
        secondaryImage.srcset = srcsetTemplate2.trim();
    }

    // Update the variant price
    if (newVariantPrice && priceElement) {
        priceElement.outerHTML = newVariantPrice;
    }

    // Update the product link with the variant ID
    if (newVariantId) {
        if (productLink) {
            let url = new URL(productLink.href);
            url.searchParams.set('variant', newVariantId);
            productLink.href = url.toString();
        }
        if (productLinkCard) {
            let url = new URL(productLinkCard.href);
            url.searchParams.set('variant', newVariantId);
            productLinkCard.href = url.toString();
        }
    }

    // Update the sold out badge
    if (button.getAttribute('data-available') === 'false') {
        const badgeHtml = `
      <span
        id="NoMediaStandardBadge-${sectionId}-${productId}"
        class="badge badge--bottom-left color-${soldOutBadgeColorScheme}"
      >
        ${soldOutText}
      </span>
    `;
        document.getElementById(`card__badge-${sectionId}-${productId}`).innerHTML = badgeHtml;

    } else {
        if (badgeElement) {
            badgeElement.remove();
        }
    }

    // Update the discount badge

    if (button.getAttribute('data-discount') == 'true') {
        const discountBadgeHtml = `
      <span
        id="NoMediaStandardBadge-${sectionId}-${productId}"
        class="badge badge--top-right color-${discountBadgeColorScheme}"
      >
        ${discountText}
      </span>
    `;
        document.getElementById(`card__badge-${sectionId}-${productId}`).innerHTML = discountBadgeHtml;

    } else {
        if (badgeElement) {
            badgeElement.remove();
        }
    }

    // Mark the selected variant
    document.querySelectorAll('.variant-button').forEach(btn => btn.classList.remove('selected'));
    button.classList.add('selected');
}
